import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useFetchWebhookInfo from '../../../hooks/useApi/useFetchWebhookInfo';
import useFetchPartnerTestWebhook from '../../../hooks/useApi/useFetchPartnerTestWebhook';
import usePostUpdateWebhook from '../../../../../../client-dashboard/src/app/hooks/useApi/usePostUpdateWebhook';
import WebhookContext, { WebhookCtx } from './Dialogue/WebhookContext';
import WebhookDialogue from './Dialogue/WebhookDialogue';
import { DialogueHandlerProps, WebhookDialogueHandler } from './Dialogue/types';
import { useClientData } from '../../../../../../client-dashboard/src/app/providers/ClientData.provider';
import { useTranslation } from 'react-i18next';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';

const { Box, Title, SubTitle, Button, BackButton } = vp;
type FC = FunctionComponent;
const Webhooks: FC = () => {
  const history = useHistory();
  const { response } = useClientData();
  const [webhookDetails, getWebhookDetails] = useFetchWebhookInfo({});
  const [testWebhookResponse, testWebhook] = useFetchPartnerTestWebhook({});
  const [updateWebhookResponse, updateWebhook] = usePostUpdateWebhook({});
  const [showDeactivateErrorAlert, setShowDeactivateErrorAlert] = useState(false);
  const [showDeactivateSuccessAlert, setShowDeactivateSuccessAlert] = useState(false);
  const [showTestErrorAlert, setShowTestErrorAlert] = useState(false);
  const [showTestSuccessAlert, setShowTestSuccessAlert] = useState(false);
  const [DeactivateError, setDeactivateError] = useState('');
  const [TestError, setTestError] = useState('');
  const [showButtons, setShowButtons] = useState(false);
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks' });
  const {
    response: { isRoleViewOnly },
  } = usePartnerLogin();
  const Webhook: WebhookCtx = {
    showDeactivateErrorAlert,
    showDeactivateSuccessAlert,
    showTestErrorAlert,
    showTestSuccessAlert,
    DeactivateError,
    TestError,
  };
  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<WebhookDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: WebhookDialogueHandler = {
        test: {
          success: {
            default: () => {
              setShowTestSuccessAlert(false);
            },
          },
          error: {
            default: () => {
              setShowTestErrorAlert(false);
              setTestError('');
            },
          },
        },
        deactivate: {
          success: {
            default: () => {
              setShowDeactivateSuccessAlert(false);
            },
          },
          error: {
            default: () => {
              setShowDeactivateErrorAlert(false);
              setDeactivateError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
  };
  useEffect(() => {
    getWebhookDetails({
      Username: response.LoginUserName,
    });
  }, []);
  useEffect(() => {
    if (updateWebhookResponse?.Success) {
      setShowDeactivateSuccessAlert(true);
      getWebhookDetails({
        Username: response.LoginUserName,
      });
    } else if (updateWebhookResponse?.Success === false) {
      setShowDeactivateErrorAlert(true);
      setDeactivateError(updateWebhookResponse?.ErrorMessage);
    }
  }, [updateWebhookResponse]);
  useEffect(() => {
    if (testWebhookResponse?.Success) {
      setShowTestSuccessAlert(true);
    } else if (testWebhookResponse?.Success === false) {
      setShowTestErrorAlert(true);
      setTestError(testWebhookResponse?.ErrorMessage);
    }
  }, [testWebhookResponse]);
  useEffect(() => {
    if (webhookDetails?.Success) {
      setShowButtons(true);
    } else {
      setShowButtons(false);
    }
  }, [webhookDetails]);
  return (
    <WebhookContext.Provider value={Webhook}>
      <div>
        <Box mb="md" jc="sb">
          <Box mb="lg" jc="fs" ai="center" gap="common">
            <BackButton variant="arrow" backButtonEnabled />
            <Title title={t('pageTitle')} />
          </Box>
          {showButtons && webhookDetails?.WebHookURL !== '' && webhookDetails && (
            <Button
              id="decativate-webhook"
              label={t('deactivateButton')}
              isDisabled={isRoleViewOnly}
              onClick={() => {
                updateWebhook({
                  PortalUser: '',
                  WebHookUrl: '',
                  Disabled: true,
                });
              }}
              color="secondary"
            />
          )}
        </Box>
        <Box flx="col">
          <Box mb="md">{t('mainDescription')}</Box>
          <Box mb="md">
            <SubTitle subTitle={t('howItWorksTitle')} />
          </Box>
          <Box mb="md">{t('howItWorksDescription')}</Box>
          <Box mb="md">
            <SubTitle subTitle={t('theRequestTitle')} />
          </Box>
          <Box mb="md">{t('theRequestDescription')}</Box>
          <Box mt="lg" jc="fe">
            {showButtons && webhookDetails?.WebHookURL !== '' && webhookDetails && (
              <Box pe="sm">
                <Button
                  id="webhook-test"
                  color="secondary"
                  label={t('testButton')}
                  isDisabled={isRoleViewOnly}
                  onClick={() => {
                    testWebhook({
                      PortalUser: '',
                    });
                  }}
                />
              </Box>
            )}
            <Box pe="sm">
              {showButtons && (
                <Button
                  id="webhook-update"
                  color="secondary"
                  isDisabled={isRoleViewOnly}
                  onClick={() => {
                    history.push('/settings/webhooks/history');
                  }}
                  label={t('historyButton')}
                />
              )}
            </Box>
            <Box>
              {showButtons && (
                <Button
                  id="webhook-update"
                  isDisabled={isRoleViewOnly}
                  onClick={() => {
                    history.push('/settings/webhooks/update');
                  }}
                  label={webhookDetails?.WebHookURL !== '' && webhookDetails ? t('manageButton') : t('activeButton')}
                />
              )}
            </Box>
          </Box>
        </Box>
      </div>
      <WebhookDialogue handleDialogue={handlers.handleDialogue} />
    </WebhookContext.Provider>
  );
};
export default Webhooks;
